"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSuburbSuggestionItemDto = instanceOfSuburbSuggestionItemDto;
exports.SuburbSuggestionItemDtoFromJSON = SuburbSuggestionItemDtoFromJSON;
exports.SuburbSuggestionItemDtoFromJSONTyped = SuburbSuggestionItemDtoFromJSONTyped;
exports.SuburbSuggestionItemDtoToJSON = SuburbSuggestionItemDtoToJSON;
exports.SuburbSuggestionItemDtoToJSONTyped = SuburbSuggestionItemDtoToJSONTyped;
var SuburbStateDto_1 = require("./SuburbStateDto");
/**
 * Check if a given object implements the SuburbSuggestionItemDto interface.
 */
function instanceOfSuburbSuggestionItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function SuburbSuggestionItemDtoFromJSON(json) {
    return SuburbSuggestionItemDtoFromJSONTyped(json, false);
}
function SuburbSuggestionItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'state': json['state'] == null ? undefined : (0, SuburbStateDto_1.SuburbStateDtoFromJSON)(json['state']),
    };
}
function SuburbSuggestionItemDtoToJSON(json) {
    return SuburbSuggestionItemDtoToJSONTyped(json, false);
}
function SuburbSuggestionItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'postcode': value['postcode'],
        'state': (0, SuburbStateDto_1.SuburbStateDtoToJSON)(value['state']),
    };
}
